export class EventAddImageMultiple {
    public eventId: number;
    public imageIdList: Array<number>;

    constructor() {
        this.imageIdList = new Array<number>();
    }
}
